import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token'); // Retrieve token from localStorage

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Render children if token is valid
  return children;
};

export default ProtectedRoute;